@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';

.mapping-list-wrapper {
  margin-top: @space-12;
}

.dropdown-title {
  margin-top: @space-24;
}

.dropdown-container {
  align-items: start;
  column-gap: @space-32;
}

.dropdown-wrapper {
  flex: 1;
}

.dropdown-menu {
  margin-top: @space-4;
}
